import { useCallback } from "react";
import { useWindowSize } from "react-use";

const breakpoints = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 992,
  xl: 1024,
  xxl: 1200,
  xxxl: 1440,
  ul: 1920,
};

export const useBreakpoint = () => {
  const { width } = useWindowSize();

  const greater = useCallback(
    (size) => {
      return width > breakpoints[size];
    },
    [width]
  );

  const greaterOrEqual = useCallback(
    (size) => {
      return width >= breakpoints[size];
    },
    [width]
  );

  const smaller = useCallback(
    (size) => {
      return width < breakpoints[size];
    },
    [width]
  );

  const smallerOrEqual = useCallback(
    (size) => {
      return width <= breakpoints[size];
    },
    [width]
  );

  const between = useCallback(
    (sizes) => {
      return width > breakpoints[sizes[0]] && width < breakpoints[sizes[1]];
    },
    [width]
  );

  return {
    greater,
    greaterOrEqual,
    smaller,
    smallerOrEqual,
    between,
    width,
  };
};
